import { render, staticRenderFns } from "./RevokeMessage.vue?vue&type=template&id=2e13e8be&scoped=true&"
import script from "./RevokeMessage.vue?vue&type=script&lang=js&"
export * from "./RevokeMessage.vue?vue&type=script&lang=js&"
import style0 from "./RevokeMessage.vue?vue&type=style&index=0&id=2e13e8be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13e8be",
  null
  
)

export default component.exports